module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-3-ad16afe64e4e649ff933d50845f0d645.webp";